export default "__VITE_ASSET__7cfe8d7b__"